<script setup>
import { useI18n } from 'vue-i18n';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';

// 导入 SVG 图片
import documentPopoverLight from 'assets/images/dashboard/pilot/document-popover-light.svg';
import documentPopoverDark from 'assets/images/dashboard/pilot/document-popover-dark.svg';

const emit = defineEmits(['click']);
const { t } = useI18n();
const onClick = () => {
  emit('click');
};
</script>

<template>
  <FeatureSpotlight
    :title="t('PILOT.KNOWLEDGE_BASES.HEADER')"
    :note="t('PILOT.KNOWLEDGE_BASES.EMPTY_STATE.DESCRIPTION')"
    :fallback-thumbnail="documentPopoverLight"
    :fallback-thumbnail-dark="documentPopoverDark"
    learn-more-url=""
    :hide-actions="true"
    class="mb-8"
  />

  <div class="flex flex-col items-center py-8">
    <!-- 顶部引导卡片已通过 FeatureSpotlight 显示 -->

    <h2
      class="text-2xl font-semibold text-n-slate-900 dark:text-n-slate-100 mb-2"
    >
      {{ t('PILOT.KNOWLEDGE_BASES.EMPTY_STATE.TITLE') }}
    </h2>
    <p class="text-n-slate-600 dark:text-n-slate-400 mb-6 max-w-md text-center">
      {{ t('PILOT.KNOWLEDGE_BASES.EMPTY_STATE.MESSAGE') }}
    </p>

    <!-- 创建按钮 -->
    <button
      class="px-4 py-2 bg-n-brand text-white rounded-lg hover:bg-n-brand-dark transition-colors mb-8"
      @click="onClick"
    >
      {{ t('PILOT.KNOWLEDGE_BASES.ADD_NEW') }}
    </button>
  </div>
</template>
